/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SearchGroup } from './SearchGroup';
import {
    SearchGroupFromJSON,
    SearchGroupFromJSONTyped,
    SearchGroupToJSON,
} from './SearchGroup';
import type { Status } from './Status';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status';
import type { StatusCodes } from './StatusCodes';
import {
    StatusCodesFromJSON,
    StatusCodesFromJSONTyped,
    StatusCodesToJSON,
} from './StatusCodes';

/**
 * 
 * @export
 * @interface SearchGroupsResponse
 */
export interface SearchGroupsResponse extends Status {
    /**
     * 
     * @type {Array<SearchGroup>}
     * @memberof SearchGroupsResponse
     */
    groups?: Array<SearchGroup>;
}

/**
 * Check if a given object implements the SearchGroupsResponse interface.
 */
export function instanceOfSearchGroupsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SearchGroupsResponseFromJSON(json: any): SearchGroupsResponse {
    return SearchGroupsResponseFromJSONTyped(json, false);
}

export function SearchGroupsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchGroupsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...StatusFromJSONTyped(json, ignoreDiscriminator),
        'groups': !exists(json, 'groups') ? undefined : ((json['groups'] as Array<any>).map(SearchGroupFromJSON)),
    };
}

export function SearchGroupsResponseToJSON(value?: SearchGroupsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...StatusToJSON(value),
        'groups': value.groups === undefined ? undefined : ((value.groups as Array<any>).map(SearchGroupToJSON)),
    };
}

